const selectors = {
  groupTriggers: ".group_trigger",
  clearFilter: ".clear-filter",
  filteredTag: ".filtered-tag",
  unfilterIcon: ".unfilter-icon",
  filterDropdowns: ".section__blog__filters__filter__content",
  filterNameLinks: ".group_trigger > a"
};

export default function init({ el, context }) {
  const nodeSelectors = {
    groupTriggers: document.querySelectorAll(selectors.groupTriggers),
    filterDropdowns: document.querySelectorAll(selectors.filterDropdowns),
    clearFilter: document.querySelector(selectors.clearFilter),
    filteredTag: document.querySelector(selectors.filteredTag),
    unfilterIcon: document.querySelector(selectors.unfilterIcon),
    filterNameLinks: document.querySelectorAll(selectors.filterNameLink)
  };

  function initFilterListeners(){

    nodeSelectors.groupTriggers.forEach((filter,index,array) => {
      filter.addEventListener("mouseenter", (e) => {
        e.preventDefault();
        let thisTrigger = e.currentTarget;
        thisTrigger.classList.toggle("active");
        let contentElement = thisTrigger.nextElementSibling;
        if (contentElement.getAttribute("aria-hidden") === "true") {
          hideOtherDropdowns(array);
          contentElement.setAttribute("aria-hidden", "false");
        } else {
          contentElement.setAttribute("aria-hidden", "true");
        }
      })
    })
    nodeSelectors.filterDropdowns.forEach((dropdown, index, array) => {
      dropdown.addEventListener("mouseout", (e) => {
        // hideOtherDropdowns(array);
        e.target.setAttribute("aria-hidden", "true");
      })
    });
    nodeSelectors.filterNameLinks.forEach(filterName => {
      filterName.addEventListener('click', e => e.preventDefault() );
    })

  }
  
  window.addEventListener('load', (e) => {
    initFilterListeners();
    const currentURL = window.location.href;
    const taggedIndex = currentURL.indexOf('tagged/');
    if ( taggedIndex !== -1 ){
      const tagName = currentURL.slice(taggedIndex + 7, currentURL.length);
      
      showUnfilterEl()
      // showTagName(tagName)
      
      nodeSelectors.unfilterIcon.addEventListener('click', e => { 
        e.preventDefault();
        unfilterResearchTag();
      })
      nodeSelectors.filteredTag.addEventListener('click', e => { 
        e.preventDefault();
        unfilterResearchTag();
      })
    }
  })

  function showUnfilterEl() {
    nodeSelectors.clearFilter.style.display = "flex";
  }
  
  function showTagName(tagName) {
    nodeSelectors.filteredTag.innerHTML = tagName;
  }

  function unfilterResearchTag(){
    if (window.location.href.indexOf('/blogs/research') > 0){
      window.location.href = '/blogs/research';
    } else if (window.location.href.indexOf('/blogs/recipes') > 0){
      window.location.href = '/blogs/recipes';
    }
  }

  function hideOtherDropdowns(array) {
    for (let i = 0; i < array.length; i++) {
      array[i].nextElementSibling.setAttribute("aria-hidden", "true");
    }
  }

}
